import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * [Model] Parse Automation Item from API response
 *
 * @public
 */
var AutomationItem = /*#__PURE__*/function () {
  function AutomationItem() {
    _classCallCheck(this, AutomationItem);
  }
  return _createClass(AutomationItem, null, [{
    key: "parseV1",
    value:
    // Properties

    /**
     * Parse snake case data
     */
    function parseV1(data) {
      var rowData = data || {};
      var item = new AutomationItem();
      item.id = rowData.automation_uid;
      item.name = rowData.name;
      item.assetType = rowData.asset_type;
      if (item.assetType === AutomationItem.ASSET_TYPE.ACS_SHEET) {
        item.historyId = rowData.history_uid;
      }
      item.sourceKeyId = rowData.source_key_uid;
      item.targetKeyId = rowData.target_key_uid;
      item.sourceProjectId = rowData.source_project_uid;
      item.targetProjectId = rowData.target_project_uid;
      item.sourceDeactivatedBy = rowData.source_deactivated_by;
      item.targetDeactivatedBy = rowData.target_deactivated_by;
      item.sourceCollectionId = rowData.source_collection_uid;
      item.sourceCollectionName = rowData.source_collection_name;
      item.targetCollectionId = rowData.target_collection_uid;
      item.targetCollectionName = rowData.target_collection_name;
      return item;
    }
  }]);
}();
AutomationItem.ASSET_TYPE = {
  ACS_FOLDER: 'acs_folder',
  ACS_SHEET: 'acs_sheet',
  ACS_DOCUMENT: 'acs_document'
};
export default AutomationItem;